import { gql } from '@apollo/client';

const DATA_WAREHOUSE_EXPORT_TYPES = gql`
    query DataWarehouseExportTypes {
        dataWarehouseExportTypes {
            totalCount
            edges {
                node {
                    id
                    name
                    description
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;

export default DATA_WAREHOUSE_EXPORT_TYPES;
